import axios from "axios";
import {AuthInfo, Dictionary, DictionaryGroup, IndexWord, Role, User, Word, SearchPositionType} from "./models/models";



axios.interceptors.response.use(
	function (response) {
		// Do something with response data
		return response;
	},
	function (error) {
		if (error.response.config.url.includes("/Api/Word/")) {
			if (error.response.status === 404) {
				return Promise.reject(error);
			}
		}
		alert(error.response.data);
		return Promise.reject(error);
	}
);



export const ServerApi = {
	getAuthInfo: async () => {
		const response = await axios.get<AuthInfo>("/Api/User/GetAuthInfo");
		return response.data;
	},



	getUsers: async (pageNumber: number, pageSize: number) => {
		const response = await axios.get<{ totalCount: number, users: User[] }>(`/Api/User/GetUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`);
		return response.data;
	},

	getManagers: async () => {
		const response = await axios.get<User[]>("/Api/User/GetManagers");
		return response.data;
	},

	updateRole: async (userId: string, role: Role) => {
		await axios.patch(`/Api/User/UpdateRole/${userId}`, {role});
	},

	deleteUser: async (userId: string) => {
		await axios.delete(`/Api/User/${userId}`);
	},



	getIndexWordIndex: async (wordId: number, dictionaryGroupIds: number[]) => {
		const response = await axios.post<number>(`/Api/Word/GetIndexWordIndex/`, {wordId, dictionaryGroupIds});
		return response.data;
	},

	getIndexWordsCount: async (dictionaryGroupIds: number[]) => {
		const response = await axios.post<number>(`/Api/Word/GetIndexWordsCount/`, {dictionaryGroupIds});
		return response.data;
	},

	getIndexWords: async (startIndex: number, stopIndex: number, dictionaryGroupIds: number[]) => {
		const response = await axios.post<IndexWord[]>(`/Api/Word/GetIndexWords`, {startIndex, stopIndex, dictionaryGroupIds});
		return response.data;
	},

	getRecentWords: async () => {
		const response = await axios.get<IndexWord[]>("/Api/Word/GetRecentWords");
		return response.data;
	},

	search: async (groupIds: number[], filterKeyword: string, inTerm: boolean, inDescription: boolean, searchPosition: SearchPositionType) => {
		const response = await axios.post<IndexWord[]>(`/Api/Word/Search`, {groupIds, filterKeyword, inTerm, inDescription, searchPosition});
		return response.data;
	},

	createWord: async (dictionaryId: number, term: string, description: string) => {
		const response = await axios.post<Word>("/Api/Word/", {dictionaryId, term, description});
		return response.data;
	},

	getWord: async (wordId: number) => {
		try {
			const response = await axios.get<Word>(`/Api/Word/${wordId}`);
			return response.data;
		} catch (e) {
			if (e.response.status === 404) {
				return null;
			}
		}
	},

	updateWord: async (wordId: number, version: number, dictionaryId: number, term: string, description: string) => {
		const response = await axios.put<Word>("/Api/Word/", {wordId, version, dictionaryId, term, description});
		return response.data;
	},

	deleteWord: async (id: number) => {
		const response = await axios.delete<Word>(`/Api/Word/${id}`);
		return response.data;
	},

	deleteManyWords: async (wordIds: number[]) => {
		const response = await axios.post<number>(`/Api/Word/DeleteMany`, {wordIds});
		return response.data;
	},



	createDictionaryGroup: async (dictionaryGroupName: string) => {
		const response = await axios.post<DictionaryGroup>("/Api/DictionaryGroup", {dictionaryGroupName});
		return response.data;
	},

	getDictionaryGroups: async (includeCount: boolean = false) => {
		const response = await axios.get<DictionaryGroup[]>(`/Api/DictionaryGroup/${includeCount}`);
		return response.data;
	},

	updateDictionaryGroup: async (dictionaryGroupId: number, dictionaryGroupName: string) => {
		const response = await axios.patch<DictionaryGroup>(`/Api/DictionaryGroup/${dictionaryGroupId}`, {dictionaryGroupName});
		return response.data;
	},

	createDictionary: async (dictionaryName: string, dictionaryGroupId: number) => {
		const response = await axios.post<Dictionary>("/Api/Dictionary", {dictionaryGroupId, dictionaryName});
		return response.data;
	},

	updateDictionary: async (dictionaryId: number, dictionaryName: string) => {
		const response = await axios.patch<Dictionary>(`/Api/Dictionary/${dictionaryId}`, {dictionaryName});
		return response.data;
	},
};